/*eslint-disable no-process-env, no-undef */
import React, { Component } from 'react'
// import ReactDOM from 'react-dom';
import PropTypes from 'prop-types'
import FacebookLogin from 'react-facebook-login'
import qs from 'qs'
const {REACT_APP_FACEBOOK_APP_ID, REACT_APP_FACEBOOK_REDIRECT_URI} = process.env

export default class FBLogin extends Component {
	state = {
		showFaq: false
	}

	constructor(props) {
		super(props)
		this.loginCallback = this.loginCallback.bind(this)
	}

	forceExit = () => {
		// this.props.history.push('/')
	}

	componentDidMount() {
		if(window.location.hash.indexOf('?') > -1) {
			// We have a query string
			this.handleMobileFbLogin()
		} else if(!this.props.sessionEmail) {
			// Redirect them out
			this.forceExit()
		}
	}

	handleMobileFbLogin = () => {
		let { email, token } = qs.parse(window.location.hash.split('?')[1])
		if(!email || !token) {
			this.forceExit()
		} else {
			// TODO: We should probably verify that this is a valid token
			this.loginCallback({accessToken: token}, email)
		}
	}

	trackInMixpanel = (e, facebookEmail, name) => {
		if(window.mixpanel){
			window.mixpanel.identify(e)
			window.mixpanel.people.set_once('$email', e)
			if(name){ window.mixpanel.people.set({'$name': name}) }
			window.mixpanel.track('Tool Facebook Authed', {
				facebookEmail,
				tool: 'AdScore'
			})
		}
	}

	loginCallback = (response, email) => {
		const e = email == null ? this.props.sessionEmail.toLowerCase() : email.toLowerCase()
		if (response.accessToken) {
			this.trackInMixpanel(e, response.email, response.name)
			this.props.facebookSessionSet(response, e)
		}
	}

	toggleFaq = () => {
		this.setState({showFaq: !this.state.showFaq})
	}

	render() {
		return (
			<FacebookLogin
				appId={REACT_APP_FACEBOOK_APP_ID}
				onClick={this.props.facebookButtonClicked}
				autoLoad={false}
				scope="ads_read,ads_management,email"
				fields="id,name,email,picture,adaccounts{name,business,amount_spent,currency,age}"
				callback={this.loginCallback}
				version="3.0"
				textButton={this.props.buttonText || "Get My Score"}
				redirectUri={REACT_APP_FACEBOOK_REDIRECT_URI}
				state={`{email=${this.props.sessionEmail}}`}
				responseType='token'
				cssClass={!this.props.enabled ? 'kep-login-facebook metro disabled' : 'kep-login-facebook metro'}
			/>
		)
	}
}

FBLogin.propTypes = {
	facebookButtonClicked: PropTypes.func,
	facebookSessionSet: PropTypes.func,
	sessionEmail: PropTypes.string,
	history: PropTypes.object,
	enabled: PropTypes.bool,
	buttonText: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/FBLogin.js